export function renderInitBannerArt(): string {
  return `
▄   ▗ ▗     ▄▖▗     ▗
▙▘█▌▜▘▜▘█▌▛▘▚ ▜▘▀▌▛▘▜▘
▙▘▙▖▐▖▐▖▙▖▌ ▄▌▐▖█▌▌ ▐▖
    `
}
